/*
 * Project: LegalPlace assistant
 * File: src/app/mutex/mutex.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpMutex {
  constructor() {
    this.mutex = {};
  }

  setMutex(mName, value) {
    this.mutex[mName] = value;
  }

  checkMutex(mName) {
    return this.mutex[mName];
  }
}

export default LpMutex;



// WEBPACK FOOTER //
// ./src/app/mutex/mutex.js